var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainScreen",attrs:{"id":"app"}},[_c('router-view'),_c('div',{staticClass:"backButton",staticStyle:{"background-color":"#269fd7"},attrs:{"small":"","fab":"","shaped":""},on:{"click":_vm.back}},[_c('v-icon',{staticStyle:{"color":"white"},attrs:{"size":"30px"}},[_vm._v("mdi mdi-chevron-left")])],1),_c('ScrollToTopButton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }